var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlog = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M21 19.5c-4 0-6 .5-9 2.5-3-2-5-2.5-9-2.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 18c2.427-1.56 4.265-1.984 6.8-2.1 1.17-.053 1.756-.08 2.164-.304.37-.204.644-.49.83-.869.206-.418.206-.968.206-2.07V2c-4.444 0-6.667 0-10 2.143M12 18c-2.427-1.56-4.265-1.984-6.8-2.1-1.17-.053-1.756-.08-2.164-.304a1.944 1.944 0 0 1-.83-.869C2 14.31 2 13.76 2 12.657V2c4.444 0 6.667 0 10 2.143M12 18V4.143"
})));
export default SvgBlog;